// extracted by mini-css-extract-plugin
export default {"noteBtn":"Note_noteBtn__kl5jP","noteContainer":"Note_noteContainer__b60yX","noteInput":"Note_noteInput__vluaR"};